import accessors from '../accessors';

const canBeSpaceResizable = (element) =>
  Boolean(accessors.getSpaceResizeConstraintForElement(element));

export default canBeSpaceResizable;
